export default "__VITE_ASSET__CZeypkPX__"